import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  button: {
    '&:disabled': {
      background: theme.palette.primary.dark,
    },
  },
}));
